module.exports = __webpack_public_path__ + "static/media/blank.2bf48bee.PNG";